export default "__VITE_ASSET__B9Zrdvi5__"